import PropTypes from "prop-types";
import dayjs from "@shared/dayjs";
import FieldLabelV1 from "./FieldLabelV1";
import DatePicker from "../v2/DatePicker";

function FieldDateV1({
  dateFormat = "MM/DD/YYYY",
  value = "",
  onChange = () => {},
  label = "",
  disabled = false,
  required = false,
  flexStyle = "tw-flex-1",
  enableTimePicker = false,
  position = "default",
  noYear = false,
}) {
  return (
    <div className={flexStyle}>
      {label && <FieldLabelV1 label={label} required={required} title={label} />}
      <div className="tw-text-sm tw-flex tw-relative tw-justify-center tw-flex-col" data-cy={`${label}`}>
        <DatePicker
          dateFormat={dateFormat}
          onChange={(dateValue) => {
            if (dateValue) {
              onChange(dayjs(dateValue, dateFormat).format("YYYY-MM-DD"));
            } else {
              onChange(dateValue);
            }
          }}
          value={value ? dayjs(value).format(dateFormat) : ""}
          inputProps={{
            placeholder: dateFormat,
            disabled,
          }}
          enableTimePicker={enableTimePicker}
          position={position}
          noYear={noYear}
        />
      </div>
    </div>
  );
}

FieldDateV1.propTypes = {
  dateFormat: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  flexStyle: PropTypes.string,
  enableTimePicker: PropTypes.bool,
  position: PropTypes.oneOf(["default", "bottom", "bottom-left"]),
  noYear: PropTypes.bool,
};

export default FieldDateV1;
